import React from 'react';
import PropTypes from 'prop-types';
import { addUrlProtocol } from '@Utils/String';

import Button from '@Components/Button';

function Text (props) {
  const { text } = props;

  return (
    <>
      {text}
      {(
        <svg className='rcs-supplier-info-table--web-address--icon'>
          <use xlinkHref='#icon-up-right'/>
        </svg>
      )
    }
    </>
  );
}

export default function WebAddress (props) {
  const { text, handleClick, disableAATracking = false } = props;
  const url = addUrlProtocol(text);
  return (
    <Button
      target='_blank'
      href={url}
      buttonConfig={{
        title: text,
        label: <Text text={text}/>,
        type: 'link',
        color: 'blue',
        aTag: disableAATracking ? false : true,
        className: 'rcs-supplier-info-table--web-address',
        e2eName: 'rcs-supplier-info-WebAddress',
      }}
      onClick={() => handleClick && handleClick(url)}
    />
  );
}

WebAddress.ropTypes = {
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  disableAATracking: PropTypes.bool,
};
